module.exports = __webpack_public_path__ + "static/media/defaultCourse.191b81dc.jpg";